import { IVerificarDados } from "src/app/core/models/search";

export class SessionStorageUtils {

    public onSaveToken(token: string) {
        sessionStorage.setItem("token", token)
    }

    public onGetToken(): string {
        return sessionStorage.getItem("token") || '3T7ARNkthpY2u9nj0U6JyGg9ZBPjt1NoF9lZmqwqhipS5rRyrHgn2AXBxRX5ewLXJn3qoRzipysmReqAeHRspnei8QFTZoTTy23C';
    }

    public onSaveExpiredToken(token: string) {
        sessionStorage.setItem("expiraToken", token)
    }
    
    public onClearSessao() {
        sessionStorage.clear()
    }
    
    public onSetDiploma(diploma: IVerificarDados) {
        sessionStorage.setItem("diploma", JSON.stringify(diploma))
    }

    public onGetDiploma(): IVerificarDados {
        return JSON.parse(sessionStorage.getItem("diploma") || '{}');
    }
    
    public onSetNumberDiploma(number: string[]) {
        sessionStorage.setItem("numberDiploma", number.join(','));
    }
    
    public onGetNumberDiploma(): string {
        return sessionStorage.getItem("numberDiploma") || '';
    }
}